import AnimatedLink from '../common/AnimatedLink';
import { useApp } from '../common/AppProvider';
import { translations } from '../translations/translations';
import { ExButton, ExIcon } from '@boomi/exosphere';
import AutosizeInput from './AutosizeInput';
import Toggle from './Toggle';
import classNames from 'classnames';

const TaskEditorHeader = ({
    taskId,
    taskName,
    isInvalidTaskName,
    isTaskActive,
    isToggleDisabled,
    onUpdateName,
    onToggle,
    onTest,
    onSave,
}: {
    taskId: string | undefined;
    taskName: string;
    isInvalidTaskName: boolean;
    isTaskActive: boolean;
    isToggleDisabled: boolean;
    onUpdateName: (taskName: string) => void;
    onToggle: () => void;
    onSave: () => void;
    onTest: () => void;
}) => {
    const { language, isOnline } = useApp();

    const headerClasses = classNames('task-editor-header', {
        'existing-task': !!taskId,
    });

    return (
        <div className={headerClasses}>
            {/* back button */}
            <AnimatedLink to={`/tasks`} tabIndex={-1} className="back-link">
                <ExButton
                    className="back-button exo-button-action"
                    flavor="branded"
                    type="tertiary"
                    size="large"
                >
                    <ExIcon className="back-icon" icon="Left arrow" hide-browser-tooltip />
                </ExButton>
            </AnimatedLink>

            {/* task name */}
            <AutosizeInput
                testId="taskNameInput"
                placeholder={translations[language].TASK_name_placeholder}
                value={taskName}
                icon="pencil"
                invalid={isInvalidTaskName}
                onUpdate={onUpdateName}
            />

            {/* task history button */}
            {taskId && (
                <>
                    <hr className="separator" />
                    <AnimatedLink
                        to={`../tasks/history?taskId=${taskId}`}
                        tabIndex={-1}
                        className="history-link"
                    >
                        <ExButton
                            className="history-button exo-button"
                            flavor="base"
                            type="tertiary"
                            size="large"
                        >
                            {translations[language].TASK_log_history}
                        </ExButton>
                    </AnimatedLink>
                </>
            )}

            {taskId && (
                <Toggle checked={isTaskActive} onToggle={onToggle} disabled={isToggleDisabled} />
            )}

            {/* test button */}
            <ExButton
                className="test-button exo-button"
                flavor="base"
                size="large"
                type="secondary"
                onClick={onTest}
                disabled={!isOnline}
            >
                {translations[language].TASK_test}
            </ExButton>

            {/* save button */}
            <ExButton
                className="save-button exo-button"
                flavor="base"
                size="large"
                type="primary"
                onClick={onSave}
                disabled={!isOnline}
            >
                {translations[language].TASK_save}
            </ExButton>
        </div>
    );
};

export default TaskEditorHeader;
